"use strict";

;
(function (FAQ, $) {
  var $searchResults = $('.hero-form-results');

  // SEARCH ALL FAQ QUESTIONS FOR REGEX MATCH
  var searchQuestions = function searchQuestions(query) {
    var regEx = "(".concat(query, ")");
    var pattern = new RegExp(regEx, "i");

    // reset everything
    var results = [];
    $searchResults.find('a').remove();

    // populate results
    $('.question p').each(function () {
      if ($(this).text().match(pattern)) {
        results.push($(this));
      }
    });

    // show only 3 results
    results = results.slice(0, 3);

    // hide everything if there are no results
    if (results.length === 0) {
      $searchResults.removeClass('active');
      return;
    }

    // include results in DOM container
    results.map(function (result) {
      var href = $(result[0]).attr('id');
      var text = $(result[0]).text();
      $searchResults.append("<a href=\"#".concat(href, "\">").concat(text, "</a>"));
    });

    // show DOM container
    if (!$searchResults.hasClass('active')) {
      $searchResults.addClass('active');
    }
  };

  // HIDE SEARCH RESULTS
  var hideResults = function hideResults() {
    $searchResults.removeClass('active');
  };

  // SHOW/HIDE ANSWER
  var toggleAnswer = function toggleAnswer(self) {
    var $parent = self.closest('.question-container');
    $parent.find('.plus').toggleClass('active');
    $parent.find('.minus').toggleClass('active');
    $parent.find('.answer').toggleClass('active');
  };
  var eventHandlers = function eventHandlers() {
    // ON INPUT, SHOW RELEVANT SEARCH RESULTS
    $('#faq-form input').on('input', function () {
      $(this).val().length > 0 ? searchQuestions($(this).val()) : hideResults();
    });

    // ON SUBMIT, GO TO FIRST SEARCH RESULT
    $('#faq-form').on('submit', function (e) {
      e.preventDefault();

      // check if there's content to search
      if ($(this).find('input').val().length === 0) {
        alert('Please type a question.');
        return;
      }
      if ($('.hero-form-results a').length) {
        var href = $('.hero-form-results a').eq(0).attr('href');
        var $element = $(href);
        toggleAnswer($element);

        // scroll to question
        $('html, body').animate({
          scrollTop: $element.offset().top - 80
        }, 0);
      }
    });

    // ON SEARCH RESULT CLICK, SHOW ANSWER
    $(document).on('click', '.hero-form-results a', function (e) {
      e.preventDefault();

      // show its answer
      var href = $(this).attr('href');
      toggleAnswer($(href));

      // scroll to question
      $('html, body').animate({
        scrollTop: $(href).offset().top - 80
      }, 0);
    });

    // SHOW/HIDE ANSWER
    $('.question').click(function () {
      toggleAnswer($(this));
    });

    // HIDE RESULTS CONTAINER
    $(document).on('click', function (e) {
      var $target = $(e.target);
      var hasFormParent = $target.closest('.hero-form-container').length;
      var hasResultsParent = $target.closest('.hero-form-results').length;
      if (!hasFormParent || !hasResultsParent) {
        hideResults();
      }
    });
  };
  FAQ.init = function () {
    eventHandlers();
  };
})(window.FAQ = window.FAQ || {}, jQuery, undefined);